export default __webpack_public_path__ + "static/media/fine.efdb55dd.png";